<template>
  <div class="obligatory-website-since-you-keep-asking-what-we-do">
    <div class="everything-is-advertising">
      <div class="all-good-tho">
        <div class="shout-out-to-felix-gonzalez-torres">
          CLOCKS, PAINT ON WALL LLC <br>
          	&copy; 2020
        </div>
        <div class="perfect-lovers">
          Clocks is a multidisciplinary practice. We are Chloe Wayne and Mahfuz Sultan. We do a bunch of stuff. Maybe we'll advertise it here in big sans serif font at some point; for now you can ask us about it at <a href="mailto:hi@clocksssss.com">hi@clocksssss.com</a>.
        </div>
        <div
          v-for="(set, i) in sets"
          :key="'set-' + i"
          class="shout-out-to-on-kawara-too"
        >
          <div :class="pClasses[i]">
            {{ set.join(' ') }}.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      sets: [],
      pClasses: ['pure-consciousness', 'toronto', 'feb-2006', 'out-of-print', 'wow', 'wow'],
    }
  },
  created() {
    this.calculateDocumentVariables();
    window.addEventListener('resize', this.$_.debounce(this.calculateDocumentVariables, 200, {
      leading: false,
      trailing: true,
    }));
  },
  mounted() {
    this.setUpNumerals();
    this.nums = this.$_.shuffle(this.nums).join(' ').repeat(10).split(' ');
    this.p1 = this.$_.shuffle(this.nums).join(' ').repeat(10).split(' ');
    this.interval = setInterval(() => {
      this.setUpNumerals();
    }, 2000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateDocumentVariables);
    clearInterval(this.interval);
  },
  methods: {
    calculateDocumentVariables() {
      const windowHeight = window.innerHeight;
      let vh = windowHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
    setUpNumerals() {
      const vm = this;
      const nums = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
      this.sets = [];
      [0, 1, 2, 3, 4, 5].forEach(v => {
        const length = [10, 12, 6, 20, 12, 8, 12];
        this.sets
          .push(this.$_.shuffle(nums)
          .join(' ')
          .repeat(length[v])
          .split(' '));
      });
    },
    onKawara() {
      console.log('shuffling')
      this.nums = this.$_.shuffle(this.nums);
    }
  }
}
</script>

<style lang="scss" scoped>


.obligatory-website-since-you-keep-asking-what-we-do {
  display: flex;
  // justify-content: center;
  // align-items: center;
  width: 100vw;
  height: calc((var(--vh, 1vh) * 100));
  padding: 32px;
  background-color: white;
  @include max-width(414) {
    padding: 16px;
  }
}

.everything-is-advertising {
  position: relative;
  width: 100vw;
  background-color: white;
  @include min-width(750) {
    max-width: 750px;
  }
}

.all-good-tho {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.shout-out-to-felix-gonzalez-torres {
  // align-self: flex-end;
  // text-align: right;
  margin-bottom: 2em;
}

.perfect-lovers, .shout-out-to-on-kawara-too {
  text-align: justify;
  line-height: 2;
  margin-bottom: 0.5em;
}
</style>
